import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { coursegroupsApi } from "./coursegroupsApi";

export const useCourseGroupTrainers = (courseGroupId: string | undefined) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_GROUP_TRAINERS(Number(courseGroupId)),
    queryFn: () => coursegroupsApi.fetchTrainers(Number(courseGroupId)),
    enabled: !!courseGroupId,
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.COURSE_GROUP_TRAINERS(Number(courseGroupId)),
    });
  };

  return { invalidate, isLoading, isFetching, trainers: data?.data.trainers ?? [] };
};
